import SiteLayout from "../../SiteLayout";
import { Peeker } from "../../ShadowMark";
import BookDemoButton from "../../BookDemoButton";
import "../../styles/about.css";

function LinkedInIcon() {
  return (
    <span className="li">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.36V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.55C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.72C24 .77 23.2 0 22.22 0z" />
      </svg>
    </span>
  );
}

const TEAM = [
  { href: "https://www.linkedin.com/in/shubham16180/", img: "team-shubham.jpg", name: "Shubham Gupta", role: "Co-Founder & CEO", bio: "IIT Delhi · Ex-Sanas", peek: true },
  { href: "https://www.linkedin.com/in/mayank-gupta-pm/", img: "team-mayank.jpg", name: "Mayank Gupta", role: "Co-Founder & CTO", bio: "IIT Roorkee · Ex-Vyapar" },
  { href: "https://www.linkedin.com/in/hersh-singh-944234166/", img: "team-hersh.jpg", name: "Hersh Singh", role: "Co-Founder & GTM Lead", bio: "University of San Francisco · Ex-Sanas" },
  { href: "https://www.linkedin.com/in/priyansh-agrawal-72192b195/", img: "team-priyansh.jpg", name: "Priyansh Agrawal", role: "Founding Engineer", bio: "IIT Delhi · Ex-Samsung Research" },
];

export default function SiteAbout() {
  return (
    <SiteLayout page="about" title="About | Shadow" navVariant="flat" navActive="about">
      <header className="hero">
        <div className="wrap">
          <div style={{ fontSize: "14px", fontWeight: 600, color: "var(--red)" }}>About</div>
          <h1>Built by operators who've<br />seen this problem firsthand.</h1>
          <p className="lede" style={{ marginLeft: "auto", marginRight: "auto" }}>We're Converse AI Inc., the team behind Shadow. We build the AI coworker for sales teams because we lived the problem it solves.</p>
        </div>
      </header>

      <section className="story">
        <div className="wrap story-grid">
          <div>
            <h2>The story so far</h2>
            <p>Our founding team built real-time voice AI for enterprise sales at Sanas, technology that worked live on calls at massive scale. That foundation, and that obsession with what happens in the moment of conversation, is baked into Shadow.</p>
            <p>We started Shadow as a real-time wingman for high-stakes calls. Then our users showed us the bigger problem: every call ends, and a new to-do list begins. A 30-minute call creates 90 minutes of work. So we rebuilt Shadow around one promise: the work your meetings create, done before they end.</p>
            <p>Where it goes from here: one coworker with your whole team's memory behind it, present across calls, email, CRM, and Slack, working for the rep, the manager, and the company.</p>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="wrap">
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "14px", fontWeight: 600, color: "var(--indigo)" }}>The team</div>
          </div>
          <div className="team-grid">
            {TEAM.map((m) => (
              <a className="tm" key={m.name} href={m.href} target="_blank" rel="noopener noreferrer">
                {m.peek && (
                  <span className="tpeek" aria-hidden="true">
                    <svg viewBox="0 0 44 16" width="40" height="15"><path d="M8 16 C 8 6, 13 1, 22 1 C 31 1, 36 6, 36 16 Z" fill="#0E0E0C" /><ellipse cx="17.5" cy="9" rx="2.4" ry="3" fill="#FFFFFF" /><ellipse cx="26.5" cy="9" rx="2.4" ry="3" fill="#FFFFFF" /></svg>
                  </span>
                )}
                <div className="ph"><img src={`/site/assets/${m.img}`} alt={m.name} /></div>
                <div className="n">{m.name}<LinkedInIcon /></div>
                <div className="r">{m.role}</div>
                <div className="b">{m.bio}</div>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="manifesto">
        <div className="wrap">
          <div style={{ fontSize: "14px", fontWeight: 600, color: "var(--gray-5)" }}>Why we're building this</div>
          <h2>Personal AI for every seller.</h2>
          <p>Every seller gets an AI that drafts in their voice, knows their accounts, and works wherever they work: calls, email, CRM, Slack. Behind it sits what no personal AI has on its own, the whole team's memory. Every play, every promise, every reason a deal was won or lost, cited and reusable. Personal in front, collective behind.</p>
          <div className="sig">SHUBHAM · MAYANK · HERSH · PRIYANSH &nbsp;/&nbsp; CONVERSE AI INC.</div>
        </div>
      </section>

      <section className="cta">
        <Peeker className="peeker" />
        <div className="wrap">
          <h2>Come work with a Shadow.</h2>
          <p>Book a demo, or write to the founders directly. We answer.</p>
          <BookDemoButton className="btn" context="About" />
        </div>
      </section>
    </SiteLayout>
  );
}
